angular
  .module('common.directives')
  .directive('surfMp4PlayerWithAccelerometer', function () {
    return {
      scope: {
        accelerometerData: '=',
        videoData: '='
      },
      templateUrl:
        './templates/surf-mp4-player-with-accelerometer.view.html?t=' +
        window.webpackHash,
      link: function ($scope, $element) {},
      controller: 'surfMp4PlayerWithAccelerometerController'
    }
  })
